import { useState } from "react";
import { Image as ExpoImage, type ImageProps, type ImageStyle } from "expo-image";
import { ImageSource } from "expo-image/src/Image.types";
import { View, Platform, type StyleProp } from "react-native";
import { useUnistyles } from "react-native-unistyles";

interface OptimizedImageProps extends Omit<ImageProps, "style"> {
  source: ImageSource | string;
  style?: StyleProp<ImageStyle>;
  loadingBackgroundColor?: string;
  showLoadingState?: boolean;
}

export function Image({
  source,
  style,
  loadingBackgroundColor,
  showLoadingState = true,
  ...rest
}: OptimizedImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const { theme } = useUnistyles();

  const defaultLoadingColor = loadingBackgroundColor || theme.colors.grey[200];

  const handleLoadStart = () => {
    if (showLoadingState) {
      setIsLoading(true);
    }
  };

  const handleLoadEnd = () => {
    if (showLoadingState) {
      setIsLoading(false);
    }
  };

  return (
    <View style={style}>
      {isLoading && showLoadingState && (
        <View
          style={[
            style,
            {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: defaultLoadingColor,
              zIndex: 1,
            },
          ]}
        />
      )}
      <ExpoImage
        source={source}
        style={style}
        contentFit="cover"
        transition={200}
        onLoadStart={handleLoadStart}
        onLoadEnd={handleLoadEnd}
        {...rest}
      />
    </View>
  );
}
